<template>
    <div class="content" >

        <toolbar v-bind:selection="toolbar" title="Nueva colmena/núcleo" />

        <p>Nueva colmena para el colmenar <b>{{infoColmenar.name}}</b></p>
        <br/>

        <v-form ref="form" v-model="valid" lazy-validation>


            <p for="date_created" class=""><b>Fecha de inicio colmena*</b></p>
            <datepicker
                    name="date_created"
                    id="date_created"
                    required
                    v-model="infoform.date_created"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>
            <p class="v-messages__message">{{errors.date}}</p>



            <!--div-- class="position-relative form-group">

                <label for="number" class="">Número de colmena</label>
                <input name="number"
                       id="number"
                       required
                       placeholder="Número de colmena"
                       type="text"
                       class="form-control" v-model="userdata.number">
            </div-->

            <v-text-field
                    v-model="infoform.number"
                    color="orange"
                    label="Número de colmena/núcleo*"
                    :rules="requiredRule"

            ></v-text-field>

            <v-text-field
                    v-model="infoform.position"
                    color="orange"
                    type="number"
                    label="Posición en colmenar"
                    :rules="requiredRule"
            ></v-text-field>


            <div class="row">
                <div class="col-d-10"><b>Núcleo</b></div>
                <div class="col-d-2">
                    <v-switch
                            color="orange"
                            v-model="infoform.core"
                            @click = "toggleclick()"
                            inset
                    ></v-switch>

                </div>
            </div>


            <div id="frames_core" style="display:none">
            <p><b>Cuadros del núcleo</b></p>
                <div class="row">

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_breeding"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Cría"
                                :items="optionsAlza"
                        ></v-select>
                    </div>
                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_honey"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Miel"
                                :items="optionsAlza"
                        ></v-select>
                    </div>
                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_pollen"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Polen"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                </div>



                <div class="row">


                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_bee"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Abejas"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_lamites"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Láminas sin estirar"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_lamites_estiradas"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Láminas estiradas"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                </div>


            </div>









            <p><b>Cuadros de la colmena*:</b> <span class="form-datepicker" style="margin-left:12px;text-align:center;">&nbsp;&nbsp;{{infoform.number_frames}}&nbsp;&nbsp;</span></p>

            <v-slider

                    v-model="infoform.number_frames"
                    color="orange"
                    max="10"
                    min="1"
                    value="5"
                    thumb-color="orange"
            ></v-slider>


            <!--div class="position-relative form-group">

                <label for="number_frames" class="">Cuadros</label>
                <input name="number_frames"
                       id="number_frames"
                       placeholder="Cuadros de la colmena"
                       number
                       class="form-control" v-model="userdata.number_frames">
            </div-->


            <!--v-select
                    v-model="infoform.type"
                    class="form-group"
                    color="orange"
                    :items="optionsType"
                    label="Tipo*"
                    data-vv-name="infoform.type"
                    required
            ></v-select-->

            <b>Tipo</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="type in optionsType" :key="type.value" style="auto">
                    <input type="radio" v-model="infoform.type" :id="type.value" :value="type.value">
                    <label class="btn" :for="type.value">{{type.text}}</label>
                </div>
            </div>

            <b>Suelo</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="floor in optionsFloor" :key="floor.value" style="auto">
                    <input type="radio" v-model="infoform.floor" :id="floor.value" :value="floor.value">
                    <label class="btn" :for="floor.value">{{floor.text}}</label>
                </div>
            </div>

            <b>Origen</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="origin in optionsOrigin" :key="origin.value" style="auto">
                    <input type="radio" v-model="infoform.origin" :id="origin.value" :value="origin.value">
                    <label class="btn" :for="origin.value">{{origin.text}}</label>
                </div>
            </div>

            <!--v-select--
                    v-model="infoform.aggressiveness"
                    class="form-group"
                    color="orange"
                    :items="optionsAggressiveness"
                    label="Agresividad*"
                    data-vv-name="infoform.aggressiveness"
                    required
            ></v-select-->

            <div class="row">
                <div class="col-d-4">
                    <b>Alza</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.alza"
                            @click="updateAlza()"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-select
                            v-model="infoform.alza_value"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="optionsAlza"
                    ></v-select>
                </div>
            </div>


            <!--div class="position-relative form-group">
                <label for="description" class="">Descripción</label>
                <textarea name="description" rows="5" id="description" class="form-control"
                          placeholder="Otros tipos, notas, información adicional"
                          v-model="userdata.description"></textarea>
            </div-->

            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Otros tipos, notas, información adicional"
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>





            <!--div-- class="position-relative form-group">
                <label for="alza">Alza</label>&nbsp;

                <input type="checkbox"
                       id="alza"
                       value="alzaCheck"
                       v-model="userdata.alza">
            </div-->

            <!--div class="position-relative form-group">
                <label for="marked">Marcada</label>&nbsp;

                <input type="checkbox"
                       id="marked"
                       value="markedCheck"
                       v-model="userdata.marked">
            </div-->

            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>

            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Aceptar
            </v-btn>

            <v-btn class="mr-4" @click="reset">
                Limpiar
            </v-btn>

        </v-form>

    </div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import axios from "axios";
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'colmena-nueva',
    components: {toolbar,loading,Datepicker},
    data() {
        return {
            toolbar: {
              return: '0',
            },

            valid: true,

            requiredRule: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],


           isloading:'',
        /* mensaje resultado form */
            alertForm:'success',
            responseform:'',
            alert: false,

            errors: {
                date:'',
            },
            infoColmenar: null,

            optionsType: [
              { text: 'Dadant', value: 'dadant' },
              { text: 'Langstroth', value: 'langstroth' },
              { text: 'Layens', value: 'layens' }
            ],

            optionsFloor: [
              { text: 'Suelo sólido', value: 'solido' },
              { text: 'Suelo antivarroa', value: 'antivarroa' },
              { text: 'Otro', value: 'otro-suelo' }
            ],

            optionsOrigin: [
              { text: 'Producción propia', value: 'propia' },
              { text: 'Comprada', value: 'compra' },
              { text: 'Otro', value: 'otro-origen' }
            ],

            optionsAlza: [
              { text: '0', value: '0' },
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '8', value: '8' },
              { text: '9', value: '9' },
              { text: '10', value: '10' }
            ],


            infoform: {
                idcolmenar: this.$route.params.id,

                date_created: (1 + new Date().getMonth()).toString() + '/' + new Date().getDate().toString() +'/' + new Date().getFullYear(),
                number: '',

                core: '',
                frame_breeding: '0',
                frame_honey: '0',
                frame_pollen: '0',
                frame_lamites: '0',
                frame_lamites_estiradas: '0',
                frame_bee: '0',

                number_frames: '5',
                type: 'dadant',
                floor: 'solido',
                origin: 'propia',
                description: '',
                alza:'',
                alza_value:'',
                position:'',
            }
        }
    },
    methods:{

        toggleclick(){
            var x = document.getElementById("frames_core");

            if(this.infoform.core){
                x.style.display = "block";
            }else{
                x.style.display = "none";
                this.infoform.frame_breeding = '0'
                this.infoform.frame_honey = '0'
                this.infoform.frame_pollen = '0'
                this.infoform.frame_lamites = '0'
                this.infoform.frame_bee = '0'
            }
        },
    updateAlza(){

            if(this.infoform.alza===true){
                this.infoform.alza_value = '1'
            }else{
                this.infoform.alza_value = '0'
            }
        },

        validate () {
            this.$refs.form.validate()
            if(this.infoform.date_created===''){
                    this.errors.date = "Debes insertar la fecha de inicio de la colmena en el colmenar."
                    this.responseform = this.errors.date
            }else{
                if(this.$refs.form.validate()){
                    this.alert = false
                    this.isloading = true

                    if(this.infoform.date_created===''){
                        this.errors.date = "Debes insertar la fecha de inicio de la colmena en el colmenar."
                    }else{

                        this.errors.date = ''
                        this.responseform = ''

                        axios.post('https://appws.panimiel.com/new/index.php/api/colmena', this.infoform)
                             .then((response) => {
                             this.responseform = response.data
                             this.alertForm = 'success'
                             this.isloading=''
                             this.alert = true
                        })
                        .catch((error) => {
                            this.alertForm = 'error',
                            this.isloading=''

                            if (error.response.status != 500){
                                this.responseform = error.response.data
                            }else{
                                this.responseform = 'Error, no ha sido posible crear la colmena.'
                            }
                             this.alert = true

                         })
                     }
                }
            }

        }
    },

     created() {

     auth.getUserLogged()


        var that = this
        axios.get("https://appws.panimiel.com/new/index.php/api/colmenar/"+this.$route.params.id).then((infoColmenar) => {
          that.infoColmenar = infoColmenar.data

        }).catch(() => {
           /* alert('error');*/
        })


      }
}

</script>

<style scoped lang="scss">
</style>